(function(window, $, deviceInfo, log, Xmp) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.fathomService = (function() {
      var _getFathomEndPoint;
      var _environments;
      var _environmentId;
      var _fathomId;
      var _getCompleteCallback;
      var _errorHandlerCallback;
      var _mockCalls = false;

      _getFathomEndPoint = '/Assessment/Xmp/';
      _environments = [];
      _environments.push({label: 'Local', url: 'https://results.localhost:444'});
      _environments.push({label: 'Dev', url: 'https://results.cloud.tsc-dev.co'});
      _environments.push({label: 'Stage', url: 'https://results.tsc-stage.co'});
      _environments.push({label: 'Live', url: 'https://results.techsmith.com'});
      _environments.push({label: 'TE', url: 'https://fathomtest2.cloud.tsc-dev.co'});
      _environmentId = 3;

      var onFathomLoad = function(xmlModel) {
         if (_getCompleteCallback) {
            _getCompleteCallback.call(this, xmlModel);
         }
      };

      var errorHandler = function() {
         if (_errorHandlerCallback) {
            _errorHandlerCallback.call();
         }
      };

      var getFathom = function() {
         if (_mockCalls) {
            setTimeout(onFathomLoad, 1000);
         } else {
            var url = _environments[_environmentId].url + _getFathomEndPoint + _fathomId + '?noop=1';

            var xmlModel = Xmp.create();
            xmlModel.load(url, true);
            xmlModel.ready.then(function() {
               onFathomLoad(xmlModel);
            }).catch(function(error) {
               log.logMessage('fathom-service: getFathom() failed. ' + error);
               errorHandler();
            });
         }
      };

      return {
         setEnvironment: function(environmentId) {
            if (isNaN(environmentId) || environmentId < 0 || environmentId > _environments.length - 1) {
               return;
            }
            _environmentId = environmentId;
         },
         getEnvironment: function() {
            return _environmentId;
         },
         getFathom: function(fathomId) {
            _fathomId = fathomId;
            getFathom();
         },
         addEventListener: function(type, listener) {
            if (type === 'GET_COMPLETE') {
               _getCompleteCallback = listener;
            } else if (type === 'ERROR') {
               _errorHandlerCallback = listener;
            }
         },
         removeEventListener: function(type) {
            if (type === 'GET_COMPLETE') {
               _getCompleteCallback = undefined;
            } else if (type === 'ERROR') {
               _errorHandlerCallback = undefined;
            }
         }
      };
   }());
}(this, window.jQuery, window.TSC.deviceInfo, window.TSC.log, window.TSC.Xmp));
